<template>
    <div :style="backUrl ? { backgroundImage: `url(${backUrl})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}" class="tab-rich-text-container">
        <!-- 顶部标题 -->
        <!-- 底部余量占位：固定高度，不拉伸内容 -->
        <div class="top-margin"></div>
        <div v-if="title" class="component-title">{{ title }}</div>

        <!-- 页签导航栏 -->
        <div class="tab-wrapper">
            <!-- 页签导航栏 - 宽度与内容区一致，均匀分布 -->
            <div class="tab-nav">
                <div
                    v-for="(tabLabel, index) in tabLabels"
                    :key="index"
                    class="tab-item"
                    :class="{ active: currentTabIndex === index }"
                    @click="switchTab(index)"
                >
                    {{ tabLabel }}
                </div>
            </div>

            <!-- 页签内容区域 - 与页签宽度一致，居中显示 -->
            <div class="tab-content">
                <div
                    :style="detailUrl ? { backgroundImage: `url(${detailUrl})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}"
                    v-for="(tabContent, index) in tabContents"
                    :key="index"
                    class="tab-panel"
                    :class="{ active: currentTabIndex === index }"
                    v-html="tabContent"
                ></div>
            </div>
            <div class="top-margin"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabRichText",
    props: {
        // 数据格式：["页签1111","页签2277777","页签222222"]@FUWENBEN@["<p>测试15</p>","<p>测试16</p>","<p>测试17</p>"]
        sourceData: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: "",
        },
        backUrl:{
            type: String,
            default: ''
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            tabLabels: [], // 页签标签数组
            tabContents: [], // 页签内容数组
            currentTabIndex: 0, // 当前激活的页签索引
        };
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newSource) {
                this.parseSourceData(newSource);
            },
        },
    },
    methods: {
        parseSourceData(source) {
            try {
                const parts = source.split("@FUWENBEN@");
                if (parts.length === 2) {
                    // 解析页签标签（假设是JSON格式的数组字符串）
                    this.tabLabels = JSON.parse(parts[0]);
                    // 解析页签内容（假设是JSON格式的数组字符串，每个元素是富文本字符串）
                    this.tabContents = JSON.parse(parts[1]);

                    // 确保页签标签和内容数量匹配，若内容少则补空
                    while (this.tabContents.length < this.tabLabels.length) {
                        this.tabContents.push("<p>无内容</p>");
                    }
                } else {
                    // 数据格式错误时的默认处理
                    this.tabLabels = ["默认页签"];
                    this.tabContents = ["<p>数据格式错误，请检查</p>"];
                }
            } catch (error) {
                console.error("页签富文本解析失败:", error);
                this.tabLabels = ["解析错误"];
                this.tabContents = ["<p>数据解析异常，请检查数据格式</p>"];
            }
        },
        switchTab(index) {
            this.currentTabIndex = index;
        },
    },
};
</script>

<style scoped>
.tab-rich-text-container {
    width: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}

.component-title {
    padding: 16px 20px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
}

/* 包裹页签和内容的容器 - 控制最大宽度并居中 */
.tab-wrapper {
    max-width: 1200px; /* 可根据需求调整最大宽度 */
    margin: 70px auto 0; /* 顶部70px margin，水平居中 */
    width: 100%;
}

/* 页签导航栏 - 均匀分布页签 */
.tab-nav {
    display: flex;
    justify-content: space-around; /* 页签均匀分布 */
    border-bottom: 1px solid #e8e8e8;
    width: 100%; /* 与内容区同宽 */
    box-sizing: border-box;
}

/* 页签样式 - 增大字体，调整间距 */
.tab-item {
    padding: 15px 20px; /* 增加内边距 */
    cursor: pointer;
    color: #666;
    font-size: 18px; /* 增大字体 */
    position: relative;
    white-space: nowrap; /* 防止页签文字换行 */
}

.tab-item.active {
    color: #ed0200;
    font-weight: 500;
}

.tab-item.active::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #ed0200;
}

/* 页签内容区域 - 与页签同宽，居中 */
.tab-content {
    margin-top: 30px;
    width: 100%; /* 与页签导航同宽 */
    box-sizing: border-box;
}

.tab-panel {
    display: none;
    padding: 20px;
    line-height: 1.8;
    color: #333;
    text-align: left; /* 富文本内容通常左对齐更易读 */
}

.tab-panel.active {
    display: block;
}

.tab-panel p {
    margin: 0 0 16px 0;
}

.tab-panel p:last-child {
    margin-bottom: 0;
}

/* 富文本图片处理 */
.tab-panel img {
    max-width: 100%;
    height: auto;
    margin: 15px 0;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .tab-nav {
        justify-content: flex-start;
        overflow-x: auto; /* 小屏页签可横向滚动 */
        padding-bottom: 5px;
    }

    .tab-item {
        font-size: 16px;
        padding: 12px 15px;
        flex-shrink: 0; /* 防止页签被压缩 */
    }
    .top-margin {
        height: 5vh; /* 小屏底部余量减少 */
    }
}
.top-margin {
    height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
</style>
